module.exports = __webpack_public_path__ + "static/apple-touch-icon-8644538e0952f25b5d858ec25cf74d87.png";